const detailSearchInfo = {
    namespaced: true,
    state : {
        searchId : '',
        searchText : '',
        searchInfo : null,
        status : ''
    },
    getters: {
        getSearchId (state) {
            return state.searchId
        },
        getSearchText (state) {
            return state.searchText
        },
        getSearchInfo (state) {
            return state.searchInfo
        },
         getStatus (state) {
            return state.status
        }
    },
    mutations: {
        setSearchId (state, payload) {
            state.searchId = payload
        },
        setSearchText (state, payload) {
            state.searchText = payload
        },
        setSearchInfo (state, payload) {
            state.searchInfo = payload;
        },
        setStatus (state, payload) {
            state.status = payload
        }
    },
    actions: {
        setSearchId ({commit}, payload) {
            commit('setSearchId', payload)
        },
        setSearchText ({commit}, payload) {
            commit('setSearchText', payload)
        },
        setSearchInfo ({commit}, payload) {
            commit('setSearchInfo', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setDetailSearchInfoInit ({commit}) {
            commit('setSearchId', '');
            commit('setSearchText', '');
            commit('setSearchInfo', null);
            commit('setStatus', '');
        }
    }
}

export default detailSearchInfo